import { v4 as uuid } from 'uuid'
import { IVendorPriceListEntry } from '../Order/OrderEntry/IVendorPriceListEntry'

export interface IFavoriteList {
  id: string
  restaurantCompanyId: string
  entries: IVendorPriceListEntry[]
}

export class FavoriteList implements IFavoriteList {
  public id: string = uuid()
  public entries: IVendorPriceListEntry[] = []

  constructor(public restaurantCompanyId: string) {}
}
